
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    TextField,
    Badge
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PushPinIcon from "@mui/icons-material/PushPin";

export const ListSelectorComponent: React.FC<{
  selectedList: ListViewModel | null,
  availableLists: ListViewModel[],
  selectList: (thisList: ListViewModel) =>  void
}> = ( {
  selectedList,
  availableLists,
  selectList
}) => {

  const styles = ContainerClasses();

  const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };


  const menuElement = (listView: ListViewModel) => {

    return (
      <MenuItem
         key={listView.Uuid_sys}
         onClick={() => {setAnchorElMenu(null);
                         selectList(listView);}}
         sx={{justifyContent: 'space-between'}}
      >
         <Typography
            sx={{ textAlign: 'center' }}
         >
           {listView.Label_sys}
         </Typography>
         {listView.user_preference?.IsPinned_sys &&
         <IconButton
           size="small"
           onClick={() => {}}
           disabled
         >
           <Badge badgeContent={listView.user_preference?.IsPinned_sys ? listView.user_preference?.Rank_sys : null}>
             <PushPinIcon fontSize="small"/>
            </Badge>
          </IconButton>
        }

      </MenuItem>
    )
  }

  const ITEM_HEIGHT=48;


  return (
    <Box sx={styles.containerRowC}>
       <Typography variant="h6">
          {selectedList?.Label_sys}
       </Typography>

      <Box>
          <IconButton
            size="large"
            onClick={handleOpenMenu}
            color="inherit"
          >
            <ArrowDropDownIcon />
          </IconButton>

          <Menu
            id="menu-list"
            anchorEl={anchorElMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElMenu)}
            onClose={handleCloseMenu}
            sx={{ display: { xs: 'block' } }}
            slotProps = {{
              paper: {
                style: {
                  maxHeight: 4.5*ITEM_HEIGHT,
                }
              }
            }}
          >
             {availableLists.map((list) => menuElement(list))}
          </Menu>
      </Box>

</Box>
);
};
